import { isCoordInElement } from "../../utils/typescript/helpers";

const dialogs: NodeListOf<HTMLDialogElement> = document.querySelectorAll(
  'dialog[id^="dialog-"]',
);

// this loop queries the trigger elements via general css selector, there is another loop below that works with data attributes
// keeping it for backwards compatibility
dialogs.forEach((dialog) => {
  const trigger: string = dialog.dataset.trigger as string;
  if (!trigger) return;

  // const dialogTrigger = document.querySelectorAll<HTMLElement>(`${trigger}, [data-${trigger}]`);
  const dialogTrigger = document.querySelectorAll<HTMLElement>(`${trigger}`);
  const closeButtons = dialog.querySelectorAll(".close");

  let originalOverflow = document.body.style.overflow;

  function handleOpen() {
    originalOverflow = document.body.style.overflow;
    document.body.style.overflow = "hidden";

    dialog.showModal();
  }

  dialogTrigger.forEach((t) => {
    t.addEventListener("click", handleOpen);
    t.addEventListener("keydown", (e) => {
      if (e.key === "Enter" || e.key === " ") {
        handleOpen();
      }
    });
  });
  dialog?.addEventListener(
    "close",
    () => (document.body.style.overflow = originalOverflow),
  );
  dialog?.addEventListener("click", (event) => {
    if (!isCoordInElement(dialog, event.clientX, event.clientY)) dialog.close();
  });
  closeButtons.forEach((closeButton) => {
    closeButton.addEventListener("click", () => {
      dialog.close();
    });
  });
});

dialogs.forEach((dialog) => {
  const trigger: string = dialog.dataset.trigger as string;
  if (!trigger) return;

  const closeTrigger = dialog.querySelector("[data-on-close-event]");

  // this condition is very likely never false should probably be removed
  // keeping it for backwards compatibility
  if (!trigger.startsWith("[role='button']")) {
    const dialogTriggers: NodeListOf<HTMLElement> = document.querySelectorAll(
      `[data-${trigger}]`,
    );
    const dialogContent: HTMLDivElement | null = dialog.querySelector(
      "div[data-dialog-content]",
    );
    const onOpenEvent = dialog.dataset.onOpenEvent as string;
    const onCloseEvent = dialog.querySelector("[on-close-event]");

    if (dialogTriggers.length === 0 || !dialogContent) return;

    closeTrigger?.addEventListener("click", (event) => {
      event.stopPropagation();

      if (onCloseEvent !== undefined) {
        document.dispatchEvent(new CustomEvent("dialog.onclose"));
      }
    });

    dialogTriggers.forEach((trigger) => {
      trigger?.addEventListener("click", (event) => {
        event.stopPropagation();

        dialog.showModal();

        if (onOpenEvent !== undefined) {
          document.dispatchEvent(new CustomEvent("dialog.onopen"));
        }
      });
    });

    if (dialogContent) {
      dialog?.addEventListener(
        "close",
        () => (document.body.style.overflow = "auto"),
      );
      dialog?.addEventListener("click", (event) => {
        if (!isCoordInElement(dialogContent, event.clientX, event.clientY))
          dialog.close();
      });
    }
  }
});
